import React from "react";

function ErrorPage({ title, message }) {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>{title}</h1>
      <p>{message}</p>
    </div>
  );
}

export default ErrorPage;
